import React, { FC } from 'react';
import { Tabs, Tab, TabList, TabPanel, TabsProps } from 'react-tabs';
import styled from 'styled-components';
import colors from '../common/theme/colors';
import constants from '../common/theme/constants';

/* Sample Usage:

    <KitTabs>
      <KitTabList>
        <KitTab>Title 1</KitTab>
        <KitTab>Title 2</KitTab>
        <KitTab>Title 3</KitTab>
      </KitTabList>
      <KitTabPanel>
        <p>Any content 1</p>
      </KitTabPanel>
      <KitTabPanel>
        <p>Any content 2</p>
      </KitTabPanel>
      <KitTabPanel>
        <p>Any content 3</p>
      </KitTabPanel>
    </KitTabs>

*/

export const StyledTabs = styled(Tabs)`
  -webkit-tap-highlight-color: transparent;
`;

interface KitTabsProps extends TabsProps {
  children?: JSX.Element | JSX.Element[] | (JSX.Element | JSX.Element[])[];
}

export const KitTabs: FC<KitTabsProps> = ({ children, onSelect, selectedIndex, className }) => {
  return (
    <StyledTabs
      selectedTabClassName='is-selected'
      selectedTabPanelClassName='is-selected'
      onSelect={onSelect}
      selectedIndex={selectedIndex}
      className={className}
    >
      {children}
    </StyledTabs>
  );
};

export const KitTabList = styled(TabList)`
  && {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    margin: 0;
    padding-inline-start: 0;
    border-bottom: 1px solid ${({ theme }) => theme.tabs.bottomBorder};
  }
`;

export const KitTab = styled(Tab)`
  cursor: pointer;
  color: ${({ theme }) => theme.tabs.text};
  font-size: ${constants.fontSize.text_14}rem;
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${constants.fontWeight.normal};
  padding: ${constants.spacing.s}rem;
  border-bottom: ${constants.border.width}px solid transparent;

  &:hover {
    border-bottom: ${constants.border.width}px solid ${colors.gray_10};
  }

  &:focus {
    outline-offset: 2px;
    outline: ${constants.border.width}px solid ${({ theme }) => theme.focus};
  }

  &.is-selected {
    color: ${({ theme }) => theme.tabs.selectedText};
    border-bottom: ${constants.border.width}px solid ${({ theme }) => theme.tabs.selectedText};
    font-weight: ${constants.fontWeight.bold};
  }
`;

export const KitTabPanel = styled(TabPanel)`
  padding: ${constants.spacing.absolute.s}px;
  @media all and (min-width: ${constants.breakpoints.xs}px) {
    padding: ${constants.spacing.absolute.m}px;
  }
  font-family: ${({ theme }) => theme.font.fontFamily};
  display: none;
  &.is-selected {
    display: block;
  }
`;
